@if(activeNumber){
    <div class="filter-active-number bg-primary">
        {{activeNumber}}
    </div>
}

